import React from 'react'
import { useRequests } from '../../requests/useRequests'
import { Formik, Form, ErrorMessage, Field, FormikHelpers } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../../state/refresh'
import { Link } from 'react-router-dom'
import AppNavBar from '../Header/AppNavBar'
import { SideMenu } from '../Header/SiteMenu'
import ButtonLink from '../Buttons/ButtonLink'

const ChangePassword = (): JSX.Element => {
  const requestMaker = useRequests()
  const dispatch = useDispatch()

  // Schema walidacji formularza
  const validationSchema = Yup.object({
    previousPassword: Yup.string()
      .required('Aktualne hasło jest wymagane'),
    password: Yup.string()
      .min(8, 'Hasło musi mieć co najmniej 8 znaków')
      .required('Nowe hasło jest wymagane'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Hasła muszą być identyczne')
      .required('Potwierdzenie hasła jest wymagane')
  })

  // Obsługa zmiany hasła
  const handleSubmit = async (
    values: {
      previousPassword: string
      password: string
      confirmPassword: string
    },
    { setSubmitting, resetForm, setFieldError }: FormikHelpers<any>
  ) => {
    try {
      await requestMaker.changePassword(values.previousPassword, values.password)
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Hasło zostało pomyślnie zmienione'
        })
      )
      resetForm()
    } catch (error: any) {
      if (error.status === 403) {
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Niepoprawne aktualne hasło'
          })
        )
      } else {
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Wystąpił błąd podczas zmiany hasła'
          })
        )
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <AppNavBar rightIcons={[]} />
      <div style={{ display: 'flex', minHeight: 'calc(100vh - 80px)' }}>
        <SideMenu />
        <section className='user-details pt-40 pb-40' style={{ flex: 1, overflow: 'auto', background: '#f8f9fa', padding: '0 24px' }}>
          <div className='container'>
            <div className='row'>
              <div className='col-sm-12 col-md-12 col-lg-8 mx-auto'>
                <div className='profile-details p-30 mb-30'>
                  <h3 className='profile-details-title mb-20 tw-font-semibold'>Zmiana hasła</h3>
                  <Formik
                    initialValues={{
                      previousPassword: '',
                      password: '',
                      confirmPassword: ''
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        <div className='form-group mb-20'>
                          <label className='form-label'>Aktualne hasło</label>
                          <Field
                            type='password'
                            name='previousPassword'
                            className='form-control'
                          />
                          <ErrorMessage name='previousPassword' component='div' className='invalid-feedback' />
                        </div>
                        <div className='form-group mb-20'>
                          <label className='form-label'>Nowe hasło</label>
                          <Field
                            type='password'
                            name='password'
                            className='form-control'
                          />
                          <ErrorMessage name='password' component='div' className='invalid-feedback' />
                        </div>
                        <div className='form-group mb-20'>
                          <label className='form-label'>Potwierdź nowe hasło</label>
                          <Field
                            type='password'
                            name='confirmPassword'
                            className='form-control'
                          />
                          <ErrorMessage name='confirmPassword' component='div' className='invalid-feedback' />
                        </div>
                        <div className='text-center mt-20'>
                          <button
                            type='submit'
                            className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                    `}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Zmienianie hasła...' : 'Zmień hasło'}
                          </button>

                          <ButtonLink
                            to='/user-profile'
                            className='tw-ml-2 tw-inline-flex tw-bg-white'
                            style={{
                              color: '#0e2b3d'
                            }}
                          >
                            Powrót do profilu
                          </ButtonLink>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default ChangePassword
